import styled from 'styled-components';

export const StyledNavLoginLink = styled.span`
    & a {
        color: #000000;
    }
`;
